import {forwardRef} from "react";
import {useUser} from "../../../../../misc/Permission";
import {Project} from "../../../../../api/Projects";
import {Company} from "../../../../../api/Companies";
import {PDF} from "../../../../../misc/pdf/parts/PDF";
import {ClientInfoContextProvider, PDFProjectContext} from "../../openings/OpeningsPDF";
import {KeyingSchedule, KeyScheduleLine} from "./KeyingSchedule";
import {Legend} from "./Legend";
import {useReadyCheck} from "../../../../../misc/pdf/UseReadyCheck";
import {CoverPage} from "../../../../../misc/pdf/parts/CoverPage";
import {Contact} from "../../../../../api/Contacts";
import {Keying2Label} from "../../../../../api/Keying2";

export const KeyingPDF = forwardRef(function (props: {
    project: Project;
    lastSubmittal: string|null;
    client?: Company;
    clientContact?: Contact;
    rows: KeyScheduleLine[];
    names: Keying2Label[];
    onReady(): void;
}, ref: any) {

    const usr = useUser();
    const ready = useReadyCheck(props.onReady);
    ready.require(!!usr);

    return (
        <div ref={ref}>
            <PDF>
                <PDFProjectContext.Provider value={props.project}>
                    <ClientInfoContextProvider client={props.client} clientContact={props.clientContact}>
                        <CoverPage title="KEYING SCHEDULE SUBMITTAL" lastSubmittal={props.lastSubmittal} />
                        <Legend names={props.names} />
                        <KeyingSchedule rows={props.rows} names={props.names} onReady={ready.section()} />
                    </ClientInfoContextProvider>
                </PDFProjectContext.Provider>
            </PDF>
        </div>
    )
})